import React from 'react';

const LoginLayout = ({ children }: { children?: React.ReactNode }) => {
  return <div className="h-[100svh] w-screen bg-revamp-cobalt-400">{children}</div>;
};

export default LoginLayout;
